import { combineReducers } from "redux";
import { rulesSelectedOptionsReducer } from "./rules_selected_options_reducer";

export const rulesTabReducer = combineReducers({
  selectedOptions: rulesSelectedOptionsReducer
});
